/* tslint:disable:align */
//============================================================================
// Name        : ReceiveItem.tsx
// Purpose     : Implement Warehouse receive UI
// Created     : 2019-06-25
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

declare var apiKey: string;
declare var apiUrl: string;
declare var apiUndoUrl: string;

// tslint:disable-next-line: no-unused-expression
/** @jsx jsx */ jsx;
import { jsx } from "@emotion/core";
import axios from "axios";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";
import swal from 'sweetalert';
import * as BinEncoder from "../../../manufacturing/binEncoder";
import Lot from "../../../manufacturing/Lot";
import { ISetPrintStateAction } from "./actions/printerActions";
import {
    IAddLotAction,
    IBeginReceptionAction,
    ICancelReceiveAction,
    IFetchItemInfoAction,
    ISaveGeneratedLabelsAction,
    ISetErrorDismissCallbackAction,
    ISetItemStorageUnitsAction,
    IShowErrorDialogAction,
    IShowUndoItemConfirmationAction
} from "./actions/receiveActions";
import ConfirmDialog from "./ConfirmDialog";
import PrintLabels from "./PrintLabels";
import ReceiveItemLot from "./ReceiveItemLot";
import ReceiveStatus from "./ReceiveStatus";
import UndoProcessDialog from "./UndoProcessDialog";
import { IItem, IPrintLabelItem, IPrintState, IReceptionItem, IStorageUnit, PrinterActions, ReceiveActions, ReceiveItemActions, ReceiveStatuses, TagType } from "./types";

class ReceiveItem extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            storageUnits: new Array<IStorageUnit>(),
            defaultStorageUnit: {},
            storageOptions: []
        };

        // Fetch the catalog item info for the receiving item
        axios.get(apiUrl + "/item-info/" + this.getItem().item_number, { params: { api_key: apiKey }})
            .then((resp) => {
                const itemInfo = {
                    itemId: this.getItem().id,
                    itemNumber: this.getItem().item_number,
                    catalogItem: resp.data.item
                };
                this.props.fetchItemInfo(itemInfo);
            })
            .catch(() => {
                $(".receive-overlay-wrapper").fadeIn();
                this.props.showError("System Error", "Unable to find items in the system. Please contact management for assistance.");
                this.props.setErrorDismissalCallback(() => history.back());
            });

        this.getStorageUnits();
    }

    getItem = () => this.props.reception.external_receive_items.find(it => it.id == this.props.externalItem);
    getStorageUnits = async () => {
        try {
            const itemNumber = this.getItem().item_number;
            const resp = await axios.get(apiUrl + `/storage-units/${itemNumber}`, { params: { api_key: apiKey }});

            const storageOptions = resp.data.map((st: IStorageUnit) => ({ value: st.id, label: st.name }));
            let defaultStorageUnit = resp.data.find((x: IStorageUnit) => x.name == "CS1");
            if (!defaultStorageUnit) {
                defaultStorageUnit = resp.data.find((x: IStorageUnit) => x.name == "CS");
            }
            if (!defaultStorageUnit) {
                defaultStorageUnit = {
                    id: 0,
                    name: "MISSING",
                    measure_unit: "1.0",
                    item_number: this.getItem().item_number
                };
            }
            this.setState({ storageUnits: resp.data as IStorageUnit[], defaultStorageUnit, storageOptions });

            // Save storage units in the item state
            this.props.setItemStorageUnits(this.getItem().item_number, resp.data, defaultStorageUnit);
        }
        catch (error) {
            alert(error);
        }
    }

    getPercentage(oldNumber: number, newNumber: number): number {
        const decVal = oldNumber - newNumber;
        return (decVal / oldNumber) * 100;
    }

    onReceive = () => {
        // Check if the item price per unit cost has fluctuated above the
        // alert threshold configured in manufacturing settings.
        const item = this.getItem();
        if (!!item.catalog_item.discarded_at) {
          return swal({ text:'Error! This item can not be received, since the item is soft-deleted.', icon: "error", className: 'swal-blue-color-for-ok' });
        }

        const storageUnit = this.state.storageUnits.find(x => x.name == item.line_uofm_code);

        if (typeof storageUnit === "undefined") {
            return alert("Error! This PO can not be received, since UOM data is missing. Please contact your administrator to add the required UOM data.");
        }

        let itemUnitCost = parseFloat(this.getItem().measure_unit_cost) / parseFloat(storageUnit.measure_unit );
        if (item.line_uofm_code == "LB" || item.line_uofm_code == "LBS") {
            itemUnitCost = parseFloat(item.measure_unit_cost);
        }

        let fluctuated = 0.0;
        if (itemUnitCost > item.average_previous_price) {
            fluctuated = this.getPercentage(itemUnitCost, item.average_previous_price);
        }
        else {
            fluctuated = this.getPercentage(item.average_previous_price, itemUnitCost);
        }

        console.log(`Unit cost: ${itemUnitCost.toFixed(2)}`);
        console.log(`Averate previous price: ${item.average_previous_price.toFixed(2)}`);
        console.log(`Fluctuated %: ${fluctuated.toFixed(2)}`);
        console.log(`Fluctuation Threshold %: ${this.props.priceFluctuationThreshold}`);

        if (fluctuated > this.props.priceFluctuationThreshold) {
            this.props.showError(
              "* SHOULD NOT PROCEED *, POSSIBLE INCORRECT PRICE DETECTED.",
              `Current price is ${itemUnitCost}, Average price is ${item.average_previous_price.toFixed(2)} thus WANING is for this reason \n \n`
            );
        }

        console.log(this.getItem());
        this.props.onReceive(this.getItem().id);
    }
    onAddLot = () => this.props.onAddLot(this.getItem().id);
    onCancelReceiveItem = () => this.props.cancelReceiveItem(this.getItem().id);

    // Handle undoing receiving items
    onConfirmUndo = () => this.props.showUndoItemConfirmation(this.onUndo, this.hideConfirm);
    hideConfirm = () => this.props.hideConfirm();

    onUndo = async () => {
        const item = this.getItem();
        let epcs = [];
        if (item.labels) {
            epcs = item.labels.map(label => {
                return label.epc;
            });
        }

        this.props.hideConfirm();
        this.props.showUndoProcess();

        try {
            const response = await axios.get(`${apiUndoUrl}/check_api_error`, { params: { api_key: apiKey, epcs: epcs, po_number: item.receiving_id } });
            if (response.data.message === 'No API Error') {
                await this.undoLiveTags(item, epcs);
            } else {
                await this.undoApiErrorTags(item, epcs);
            }
        } catch (error) {
            this.props.showError('API Error', error.response.data.message);
        }
    }

    undoLiveTags = async (item: IReceptionItem, epcs: Array<string>) => {
        this.setState({ undo: { ...this.state.undo, states: ['checkTagsLive', 'checkTagsQuantities', 'checkTagAllocations', 'checkNAV'], checkTagsLive: "loading" } });
        try {
            await axios.get(`${apiUndoUrl}/check_tags_live_status`, { params: { api_key: apiKey, epcs } });
            this.setState({ undo: { ...this.state.undo, checkTagsLive: "success" } });
        } catch (error) {
            this.setState({ undo: { ...this.state.undo, checkTagsLive: "failed", error: { ...error.response.data, type: 'live_status' } } });
            return;
        }

        this.setState({ undo: { ...this.state.undo, checkTagsQuantities: "loading" } });
        try {
            await axios.get(`${apiUndoUrl}/check_tags_quantities`, { params: { api_key: apiKey, epcs } });
            this.setState({ undo: { ...this.state.undo, checkTagsQuantities: "success" } });
        } catch (error) {
            this.setState({ undo: { ...this.state.undo, checkTagsQuantities: "failed", error: { ...error.response.data, type: 'quantities' } } });
            return;
        }

        this.setState({ undo: { ...this.state.undo, checkTagAllocations: "loading" } });
        try {
            await axios.get(`${apiUndoUrl}/check_so_allocations`, { params: { api_key: apiKey, epcs } });
            this.setState({ undo: { ...this.state.undo, checkTagAllocations: "success" } });
        } catch (error) {
            this.setState({ undo: { ...this.state.undo, checkTagAllocations: "failed", error: { ...error.response.data, type: 'allocations' } } });
            return;
        }

        this.setState({ undo: { ...this.state.undo, checkNAV: "loading" } });
        try {
            await axios.post(`${apiUndoUrl}`, {
                api_key: apiKey,
                receivingId: this.props.reception.receiving_id,
                itemId: item.id,
                extReceiveId: this.props.reception.receiving_id,
                epcs,
                call_nav: true
            });
            this.setState({ undo: { ...this.state.undo, checkNAV: "success" } });
        } catch (error) {
            this.setState({ undo: { ...this.state.undo, checkNAV: "failed", error: { ...error.response.data, type: 'nav' } } });
            return;
        }
    }

    undoApiErrorTags = async (item: IReceptionItem, epcs: Array<string>) => {
        this.setState({ undo: { ...this.state.undo, states: ['checkTagsQuantities'], checkTagsQuantities: "loading" } });
        try {
            await axios.get(`${apiUndoUrl}/check_tags_quantities`, { params: { api_key: apiKey, epcs } });
            this.setState({ undo: { ...this.state.undo, checkTagsQuantities: "success" } });
        } catch (error) {
            this.setState({ undo: { ...this.state.undo, checkTagsQuantities: "failed", error: { ...error.response.data, type: 'quantities' } } });
            return;
        }

        this.setState({ undo: { ...this.state.undo, checkTagsKilled: "loading" } });
        try {
            await axios.post(`${apiUndoUrl}`, {
                api_key: apiKey,
                receivingId: this.props.reception.receiving_id,
                itemId: item.id,
                extReceiveId: this.props.reception.receiving_id,
                epcs,
                call_nav: false
            });
            this.setState({ undo: { ...this.state.undo, checkTagsKilled: "success" } });
        } catch (error) {
            this.setState({ undo: { ...this.state.undo, checkTagsKilled: "failed", error: { ...error.response.data, type: 'nav' } } });
            return;
        }
    }

    onPrintLabels = async () => {
        const item: IReceptionItem = this.getItem();
        const resp = await axios.get(apiUrl + "/last-encoded-serial", {
            params: {
                api_key: apiKey,
                incrementSerialCount: this.incrementSerialCount(item)
            }
        });
        const lastSerial = resp.data.lastEncodedSerial;

        // Save last serial
        const labels = this.generateLabels(item, lastSerial);

        // Save the generated labels to the store
        this.props.saveGeneratedLabels(this.props.externalItem, labels);
        axios.post(apiUrl + `/save-labels`, {
            api_key: apiKey,
            itemId: this.getItem().id,
            extReceiveId: this.getItem().ext_receive_id,
            receivingItemNumber: this.getItem().item_number,
            itemNumber: this.getItem().catalogItem.number,
            labels
        })
        .then(() => {
            let palletCount = 0;
            let caseCount   = 0;
            item.lots.map((lot: Lot, _idx) => {
                palletCount += parseInt(lot.palletCount, 10);
                caseCount   += parseInt(lot.individualCases, 10);
            });
            this.props.setPrintState({ palletCount, caseCount });

            // Show print labels dialog
            this.props.printLabels();
        })
        .catch(error => {
            alert(error);
        });
    }

    incrementSerialCount = (item: IReceptionItem): number => {
        let serialCount = 0;
        item.lots.map((lot: Lot, idx) => {
            const palletCount: number = parseInt(lot.palletCount, 10);
            const casesCount: number = parseInt(lot.individualCases, 10);

            serialCount += palletCount;
            serialCount += casesCount;
        });
        return serialCount;
    }

    generateLabels = (item: IReceptionItem, lastSerial: number): IPrintLabelItem[] => {
        const storageUnit: IStorageUnit = item.storageUnits.find(x => x.name == item.line_uofm_code);
        const labels: IPrintLabelItem[] = [];
        const lotCount = item.lots.length;
        const itemUom = item.line_uofm_code;

        const allLotsQty = item.lots.reduce((acc, lot) => {
            const lotSum = (parseInt(lot.palletCount, 10) * parseInt(lot.palletCases, 10)) + parseInt(lot.individualCases, 10);
            return acc + lotSum;
        }, 0);
        const allLotsQtyInLbs = allLotsQty * parseFloat(storageUnit.measure_unit);

        item.lots.map((lot: Lot, idx) => {
            // Generate Pallet EPCs
            const lotNumber = moment(lot.lotNumber).format("YYYYMMDD");
            const palletCount: number = parseInt(lot.palletCount, 10);
            for (let i = 1; i <= palletCount; i++) {
                console.log(lastSerial);
                const itemBin   = BinEncoder.decimalToBinary(item.catalogItem.number, this.props.epcEncodingInfo.itemLength);
                const serialBin = BinEncoder.decimalToBinary(lastSerial, this.props.epcEncodingInfo.serialLength);
                const palletBin = BinEncoder.decimalToBinary(i, this.props.epcEncodingInfo.palletLength);
                const casesBin  = BinEncoder.decimalToBinary(0, this.props.epcEncodingInfo.caseLength);

                const binEpc = this.props.epcEncodingInfo.prefix + itemBin + serialBin + palletBin + casesBin;
                const epc    = BinEncoder.binaryToHex(binEpc).result;
                console.log(epc);

                let qtyInOrigStorageUnit = parseInt(lot.palletCases, 10);
                if (lot.storageUnit.label != itemUom || lot.hasCustomStorageUnit) {
                    if (itemUom == "LB" || itemUom == "LBS") {
                        qtyInOrigStorageUnit = qtyInOrigStorageUnit * lot.getMeasureUnit(item.storageUnits);
                    }
                    else {
                        if (itemUom == "KG" || itemUom == "KL" || itemUom == "PALLET") {
                            const st = item.storageUnits.find(x => x.name == itemUom);
                            qtyInOrigStorageUnit = qtyInOrigStorageUnit * (lot.getMeasureUnit(item.storageUnits) / parseFloat(st.measure_unit));
                        }
                    }
                }
                else {
                    if (itemUom == "LB" || itemUom == "LBS") {
                        qtyInOrigStorageUnit = qtyInOrigStorageUnit * parseFloat(this.state.defaultStorageUnit.measure_unit);
                    }
                    if (itemUom == "PALLET") {
                        qtyInOrigStorageUnit = 1;
                    }
                }

                let currentUnits = parseInt(lot.palletCases, 10);
                if ((lot.storageUnit.label == "LB" || lot.storageUnit.label == "LBS" || lot.storageUnit.label == "EA") && !lot.hasCustomStorageUnit) {
                    currentUnits = currentUnits * lot.getMeasureUnit(item.storageUnits) * parseFloat(this.state.defaultStorageUnit.measure_unit);

                    if (lot.storageUnit.label == "EA") {
                        currentUnits = currentUnits * lot.getMeasureUnit(item.storageUnits);
                    }
                }
                else {
                    currentUnits = currentUnits * lot.getMeasureUnit(item.storageUnits);
                }

                const label: IPrintLabelItem = {
                    // Original data
                    inputQty:            Number(lot.receiveQty),
                    inputUom:            lot.storageUnit.label,

                    individualCase:      false,
                    itemDescription:     item.catalogItem.description,
                    itemAlu:             item.catalogItem.alu,
                    epc,
                    itemNumber:          item.catalogItem.number,
                    itemExpDate:         item.expected_receipt_date,
                    receivingId:         item.receiving_id,
                    receivingItemId:     item.id,
                    lotIdx:              idx + 1,
                    lotCount,
                    palletCases:         parseInt(lot.palletCases, 10),
                    storageUnit:         lot.hasCustomStorageUnit ? lot.customStorageUnit : this.state.defaultStorageUnit.measure_unit,
                    selectedStorageUnit: lot.getStorageUnitName(item.storageUnits),
                    qtyInOrigStorageUnit,
                    missingExpDate:      lot.missingExpDate,

                    // Asset fields
                    serialNumber:        lastSerial,
                    lotNumber,
                    lotExpDate:          lot.expirationDate,
                    tagType:             TagType.Pallet,
                    orgUnits:            item.expected_qty,
                    currentUnits,
                    costPerStorageUnit:  item.receive_price / (allLotsQty * parseFloat((lot.hasCustomStorageUnit ? lot.customStorageUnit : this.state.defaultStorageUnit.measure_unit))),
                    costPerContainer:    item.receive_price / allLotsQtyInLbs,
                    palletNumber:        i,
                    caseNumber:          0,

                    // Label count
                    currentLabelNum:     i,
                    ofTotalLabelCount:   palletCount,
                    verified:            false
                };
                console.log(label);
                labels.push(label);
                lastSerial++;
            }

            // Generate Case EPCs
            const casesCount: number = parseInt(lot.individualCases, 10);
            for (let i = 1; i <= casesCount; i++) {
                const itemBin   = BinEncoder.decimalToBinary(item.catalogItem.number, this.props.epcEncodingInfo.itemLength);
                const serialBin = BinEncoder.decimalToBinary(lastSerial, this.props.epcEncodingInfo.serialLength);
                const palletBin = BinEncoder.decimalToBinary(0, this.props.epcEncodingInfo.palletLength);
                const casesBin  = BinEncoder.decimalToBinary(i, this.props.epcEncodingInfo.caseLength);

                const binEpc = this.props.epcEncodingInfo.prefix + itemBin + serialBin + palletBin + casesBin;
                const epc    = BinEncoder.binaryToHex(binEpc).result;
                console.log(epc);

                let qtyInOrigStorageUnit = 1;
                if (lot.storageUnit.label != itemUom || lot.hasCustomStorageUnit) {
                    if (itemUom == "LB" || itemUom == "LBS" || lot.storageUnit.label == "EA") {
                        qtyInOrigStorageUnit = qtyInOrigStorageUnit * lot.getMeasureUnit(item.storageUnits);
                    }
                    else {
                        if (itemUom == "KG" || itemUom == "KL") {
                            const st = item.storageUnits.find(x => x.name == itemUom);
                            qtyInOrigStorageUnit = qtyInOrigStorageUnit * (lot.getMeasureUnit(item.storageUnits) / parseFloat(st.measure_unit));
                        }
                    }
                }
                else {
                    if (itemUom == "LB" || itemUom == "LBS") {
                        qtyInOrigStorageUnit = qtyInOrigStorageUnit * parseFloat(this.state.defaultStorageUnit.measure_unit);
                    }
                }

                let currentUnits = lot.getMeasureUnit(item.storageUnits);
                if ((lot.storageUnit.label == "LB" || lot.storageUnit.label == "LBS" || lot.storageUnit.label == "EA") && !lot.hasCustomStorageUnit) {
                    currentUnits = parseFloat(this.state.defaultStorageUnit.measure_unit);
                }

                // const inLbs: number = parseFloat(storageUnit.measure_unit);
                const label: IPrintLabelItem = {
                    // Original data
                    inputQty:            Number(lot.receiveQty),
                    inputUom:            lot.storageUnit.label,

                    individualCase:      true,
                    itemDescription:     item.catalogItem.description,
                    itemAlu:             item.catalogItem.alu,
                    epc,
                    itemNumber:          item.catalogItem.number,
                    itemExpDate:         item.expected_receipt_date,
                    receivingId:         item.receiving_id,
                    receivingItemId:     item.id,
                    lotIdx:              idx + 1,
                    lotCount,
                    palletCases:         0,
                    storageUnit:         lot.hasCustomStorageUnit ? lot.customStorageUnit : this.state.defaultStorageUnit.measure_unit,
                    selectedStorageUnit: lot.getStorageUnitName(item.storageUnits),
                    qtyInOrigStorageUnit,
                    missingExpDate:      lot.missingExpDate,

                    // Asset fields
                    serialNumber:        lastSerial,
                    lotNumber,
                    lotExpDate:          lot.expirationDate,
                    tagType:             TagType.Case,
                    orgUnits:            item.expected_qty,
                    currentUnits,
                    costPerStorageUnit:  item.receive_price / (allLotsQty * parseFloat((lot.hasCustomStorageUnit ? lot.customStorageUnit : this.state.defaultStorageUnit.measure_unit))),
                    costPerContainer:    item.receive_price / allLotsQtyInLbs,
                    palletNumber:        0,
                    caseNumber:          i,

                    // Label count
                    currentLabelNum:     i,
                    ofTotalLabelCount:   casesCount,
                    verified:            false
                };
                console.log(label);
                labels.push(label);
                lastSerial++;
            }
        });
        return labels;
    }

    getAllLotsValid = (): boolean => {
        return this.getItem().lots.filter((x: Lot) => x.isValid && x.confirmLotValid(this.getItem().defaultStorageUnit)).length == this.getItem().lots.length;
    }

    showValidationError = () => {
        this.props.showError("Validation Error", this.props.errorMsg);
    }

    onShowCancelConfirmation = () => {
        this.props.showCancelConfirmation(this.onCancelReceiveItem, this.props.hideCancelConfirmation);
    }

    render() {
        const isReceiving = this.getItem().isReceiving;
        const status = this.getItem().status;
        return (
            <React.Fragment>
            <tr>
                <td>{this.getItem().item_number}</td>
                <td>{this.getItem().item_description}</td>
                <td>{this.getItem().line_uofm_code}</td>
                <td>{this.getItem().expected_qty}</td>
                <td style={{ textAlign: "right" }}>
                    {!(status == ReceiveStatuses.Complete) &&
                        !isReceiving && !this.getItem().blocked &&
                        <button onClick={this.onReceive} className="man-btn man-wide-btn man-green-btn">Start Receiving</button>}

                    {(this.getItem().blocked || isReceiving) && <ReceiveStatus addedClass="mf-receiving-row-label" status={status} />}

                    {(status == ReceiveStatuses.Complete) && <button onClick={this.onConfirmUndo} className="man-btn">Undo</button>}
                </td>
            </tr>
            <tr style={{ border: "0px", marginBottom: "20px" }}>
                <td colSpan={5} className="mf-table-receiving-row">
                {this.getItem().isReceiving && <div className="mf-table mf-table-receiving-row-table table-responsive col-md-12">
                    <table className="table table-bordered table-striped">
                    <thead>
                        <tr>
                        <th>Total Received Qty</th>
                        <th>UOM</th>
                        <th>Lot Date</th>
                        <th>Exp Date</th>
                        <th># of Pallets</th>
                        <th>Cases Per Pallet</th>
                        <th># Additional Cases</th>
                        <th>LB / EA per Case</th>
                        <th>VALIDATION</th>
                        <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.getItem().lots.map((lot: Lot, key: React.ReactText) =>
                            <ReceiveItemLot
                                itemId={this.getItem().id}
                                lot={lot}
                                storageUnits={this.state.storageOptions}
                                defaultStorageUnit={this.state.defaultStorageUnit}
                                key={key} />
                        )}
                        <tr>
                            <td colSpan={10}>
                                <div className="mf-receiving-row-actions">
                                <button onClick={this.onAddLot} className="man-btn mf-receiving-row-action-add">
                                    <img className="mf-add-img" src="/images/add.png" alt="Add"/>
                                    <span>Add Additional Lot</span>
                                </button>
                                <div>
                                    {!this.getAllLotsValid() && <button onClick={this.showValidationError} className="man-btn">Validation Issues</button>}

                                    <button onClick={this.onShowCancelConfirmation} className="man-btn">Cancel</button>
                                    {(this.getItem().qtyValid && this.getAllLotsValid()) && <button onClick={this.onPrintLabels} className="man-btn man-green-btn">Print Labels</button>}
                                </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    </table>

                    <ConfirmDialog
                        show={this.props.showConfirmation}
                        title={this.props.confirmationTitle}
                        message={this.props.confirmationMsg}
                        positiveBtnLbl="Yes"
                        negativeBtnLbl="No" />

                    <PrintLabels itemId={this.getItem().id} />

                </div>}

                {this.state.undo &&
                    <UndoProcessDialog
                        show={this.props.showUndoProcessDialog}
                        {...this.state.undo}
                    />
                }
                </td>
            </tr>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    priceFluctuationThreshold: state.receiveOrders.priceFluctuationThreshold,
    reception:                 state.receiveOrders.reception,
    epcEncodingInfo:           state.receiveOrders.epcEncodingInfo,
    errorMsg:                  state.receiveOrders.errorMsg,
    showConfirmation:          state.receiveOrders.showItemConfirmation,
    confirmationTitle:         state.receiveOrders.confirmationTitle,
    confirmationMsg:           state.receiveOrders.confirmationMsg,
    confirmationCallback:      state.receiveOrders.positiveConfirmationCallback,
    showUndoProcessDialog:     state.receiveOrders.showUndoProcess
});

const mapDispatchToProps = dispatch => ({
    updateState: (newState: object) => dispatch({
        type: ReceiveItemActions.UpdateState,
        payload: newState
    }),
    fetchItemInfo: (itemInfo: object) => dispatch({
        type: ReceiveActions.FetchItemInfo,
        payload: itemInfo
    } as IFetchItemInfoAction),
    onReceive: (id: number) => dispatch({
        type: ReceiveActions.BeginReception,
        payload: { id }
    } as IBeginReceptionAction),
    onAddLot: (itemId: number) => dispatch({
        type: ReceiveActions.AddLot,
        payload: { itemId }
    } as IAddLotAction),
    showCancelConfirmation: (positiveCb, negativeCb) => dispatch({
        type: ReceiveActions.ShowCancelItemConfirmation,
        payload: { positiveCb, negativeCb }
    }),
    hideCancelConfirmation: () => dispatch({
        type: ReceiveActions.HideCancelItemConfirmation
    }),
    hideConfirm: () => dispatch({
        type: ReceiveActions.HideCancelConfirmation
    }),
    showUndoItemConfirmation: (callback: () => void, negativeCb: () => void) => dispatch({
        type: ReceiveActions.ShowUndoItemConfirmation,
        payload: { callback, negativeCb }
    } as IShowUndoItemConfirmationAction),
    showUndoProcess: () => dispatch({
        type: ReceiveActions.ShowUndoProcess
    }),
    cancelReceiveItem: (itemId: number) => dispatch({
        type: ReceiveActions.CancelReceiveItem,
        payload: { itemId }
    } as ICancelReceiveAction),
    printLabels: () => dispatch({
        type: ReceiveActions.PrintLabels
    }),
    showError: (errorTitle: string, errorMsg: string) => dispatch({
        type: ReceiveActions.ShowErrorDialog,
        payload: {
            errorTitle,
            errorMsg
        }
    } as IShowErrorDialogAction),
    setErrorDismissalCallback: (callback: () => void) => dispatch({
        type: ReceiveActions.SetErrorDismissCallback,
        payload: { callback }
    } as ISetErrorDismissCallbackAction),
    setItemStorageUnits: (itemNumber: string, storageUnits: IStorageUnit[], defaultStorageUnit: IStorageUnit) => dispatch({
        type: ReceiveActions.SetItemStorageUnits,
        payload: {
            itemNumber,
            storageUnits,
            defaultStorageUnit
        }
    } as ISetItemStorageUnitsAction),
    saveGeneratedLabels: (itemId: number, labels: IPrintLabelItem[]) => dispatch({
        type: ReceiveActions.SaveGeneratedLabels,
        payload: {
            itemId,
            labels
        }
    } as ISaveGeneratedLabelsAction),
    setPrintState: (props: Partial<IPrintState>) => dispatch({
        type: PrinterActions.SetPrintState,
        payload: { props }
    } as ISetPrintStateAction)
});

export default connect(mapStateToProps, mapDispatchToProps)(ReceiveItem);
